import { LayoutPlugin } from './LayoutPlugin';
export default LayoutPlugin;